import { render, staticRenderFns } from "./SidebarFiltersProvider.vue?vue&type=template&id=023789b8&"
import script from "./SidebarFiltersProvider.vue?vue&type=script&lang=js&"
export * from "./SidebarFiltersProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SidebarFiltersProvider.vue"
export default component.exports